import React from "react";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import AppRoutes from "./routes/AppRoutes"; // Import your routing logic

const App = () => {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
